import React, { useState, useEffect } from "react";
import { Table, Badge, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api, { getFileUrl } from "../../../../api";
import Swal from "sweetalert2";
import VerifiedCopyActions from "../../Common/VerifiedCopyActions";

const ContractualWoTab = ({ workOrderId, workOrder }) => {
 const navigate = useNavigate();
 const [cwos, setCwos] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 fetchCWOs();
 }, [workOrderId]);

 const fetchCWOs = async () => {
 try {
 setLoading(true);
 const res = await api.get(`/contractual-work-orders?workOrder=${workOrderId}`);
 if (res.data.success) setCwos(res.data.data);
 } catch (err) {
 console.error(err);
 } finally {
 setLoading(false);
 }
 };

 const statusVariant = (status) => {
 switch (status) {
 case "Approved": return "success";
 case "Rejected": return "danger";
 case "In Progress": return "warning";
 case "Completed": return "info";
 default: return "secondary";
 }
 };

 const handleDownloadPdf = async (id) => {
 try {
 const token = localStorage.getItem("token");
 const url = getFileUrl(`/api/contractual-work-orders/download-pdf/${id}`);

 const response = await fetch(url, {
 method: 'GET',
 headers: {
 'Authorization': `Bearer ${token}`,
 'Accept': 'application/pdf'
 }
 });

 if (!response.ok) throw new Error("Failed to generate PDF");

 const blob = await response.blob();
 const downloadUrl = window.URL.createObjectURL(blob);
 const link = document.createElement('a');
 link.href = downloadUrl;
 link.setAttribute('download', `CWO_${new Date().getTime()}.pdf`);
 document.body.appendChild(link);
 link.click();
 link.remove();
 window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 3000);
 } catch (err) {
 console.error(err);
 Swal.fire("Error", "Failed to download PDF", "error");
 }
 };

 if (loading) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>;

 return (
 <div className="card">
 <div className="card-header d-flex justify-content-between align-items-center">
 <h4 className="card-title mb-0">Contractual Work Orders</h4>
 <Button 
 variant="primary" 
 size="sm" 
 onClick={() => navigate(`/contractual-debit/add?${workOrder?.project ? `project=${workOrder.project?._id || workOrder.project}&` : ""}workOrder=${workOrderId}`)}
 >
 <i className="fa fa-plus me-2"></i> Create New CWO
 </Button>
 </div>
 <div className="card-body p-0">
 <Table responsive hover className="mb-0 text-center align-middle">
 <thead className="bg-light">
 <tr>
 <th>CWO No</th>
 <th>Vendor</th>
 <th>Items</th>
 <th>Total Amount</th>
 <th>Status</th>
 <th className="text-center">Actions</th>
 </tr>
 </thead>
 <tbody>
 {cwos.map((item) => (
 <tr key={item._id} className="align-middle">
 <td>{item.cwoNo}</td>
 <td>{item.vendor?.name || "—"}</td>
 <td>{item.selectedBoqItems?.length} Items</td>
 <td>₹{item.totalAmount?.toLocaleString()}</td>
 <td>
 <div className="d-flex justify-content-center">
 <Badge className="rounded-pill" bg={statusVariant(item.status)}>{item.status}</Badge>
 </div>
 </td>
 <td>
 <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
 <VerifiedCopyActions
 id={item._id}
 type="contractual-work-orders"
 moduleKey="contractualwo"
 hasVerifiedCopy={Boolean(item.verifiedCopy?.filePath || item.verifiedCopy?.fileUrl)}
 verifiedCopy={item.verifiedCopy}
 onUploadSuccess={fetchCWOs}
 />
 <Button 
 variant="outline-primary" 
 size="sm" 
 className="border-0"
 onClick={() => navigate(`/contractual-debit/edit/${item._id}${workOrder?.project ? `?project=${workOrder.project?._id || workOrder.project}` : ""}`)}
 >
 <i className="fa fa-edit"></i>
 </Button>
 </div>
 </td>
 </tr>
 ))}
 {cwos.length === 0 && (
 <tr>
 <td colSpan="6" className="text-center text-muted py-4">No contractual work orders found for this WO.</td>
 </tr>
 )}
 </tbody>
 </Table>
 </div>
 </div>
 );
};

export default ContractualWoTab;
